import { createColor } from '~/_shared/components/colorPicker/colorPicker.helpers';
import {
  MarkerStyleType, type MarkerVisualSettings,
} from '~/_shared/types/marker.types';
import {
  getContrastColor, getNextColorFromPresets,
} from '~/_shared/utils/colors/colors.helpers';
import type { TranslationFnc } from '~/_shared/utils/hooks';
import type { PlacesSearch } from '~/store/mapSettings/places/mapSettingsPlaces.state';

export const PRESET_COLORS_PLACES = ['#7db3e1', '#25ae60', '#f15c5a', '#f99d1c', '#8963aa', '#535352', '#f4db0a'] as const;

export const getNextPlacesSearchColor = (usedColors: string[]) => {
  return getNextColorFromPresets(usedColors, PRESET_COLORS_PLACES);
};

export const getPlacesToolCircleColors = (placeColor: string) => {
  const backgroundColor = createColor(placeColor);
  const baseFontColor = createColor('#ffffff');
  const color = getContrastColor(baseFontColor, backgroundColor);

  return { backgroundColor, color };
};

const DIMENSION = 32;
export const PLACES_MARKER_DIMENSIONS = { height: DIMENSION, width: DIMENSION };
const PLACES_MARKER_SIZE = 41;
const DEFAULT_PLACES_MARKER_STYLE = 31;
export const getPlacesMarkerProps = ({
  placeColor,
}: {
  placeColor: string;
}) => {
  const markersSettings: MarkerVisualSettings = {
    selectedColor: placeColor,
    styleType: MarkerStyleType.STANDARD,
    styleId: DEFAULT_PLACES_MARKER_STYLE,
    size: PLACES_MARKER_SIZE,
  };

  return {
    markerSettings: {
      marker: markersSettings,
      useMarker: true,
    },
    maxDimensions: PLACES_MARKER_DIMENSIONS,
    maxSize: PLACES_MARKER_SIZE,
  };
};

export const getPlaceSearchName = (search: PlacesSearch, t: TranslationFnc) => {
  return t('placesTool.listingHeader', { field: search.text, center: search.center.name });
};
